import { render, staticRenderFns } from "./BuscadorProductos.vue?vue&type=template&id=795c38d6"
import script from "./BuscadorProductos.vue?vue&type=script&lang=js"
export * from "./BuscadorProductos.vue?vue&type=script&lang=js"
import style0 from "@riophae/vue-treeselect/dist/vue-treeselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BuscadorProductos.vue?vue&type=style&index=1&id=795c38d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports